/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');

var SubmitContact = require('../../contact/services/SubmitContact');

var tmplCreateNewContactModalView = require('../templates/COCCreateNewContactModalView.hbs');
var COCContactFormView = require('../../contact/views/COCContactFormView');

module.exports = Marionette.LayoutView.extend({
  template: tmplCreateNewContactModalView,

  className: 'coc-create-new-contact-modal-view',

  ui: {
    contactFormContainer: '.contact-form-container',
    submit: '.btn-submit'
  },

  regions: {
    contactFormContainer: '@ui.contactFormContainer'
  },
  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.contactForm = new COCContactFormView({ model: this.model });
    this.showChildView('contactFormContainer', this.contactForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submit.get(0));
        laddaContext.start();
        SubmitContact(self.getFormData()).done(function(newContact) {
          self.triggerMethod('modal:close', newContact);
        });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.contactFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    return this.contactForm.getFormData();
  }
});
